<div class="declaration-page-container" *ngIf="declarationDto">
  <h1 class="page-title vo-heading-regular-22 my-15" [innerHtml]="declarationDto.Labels[referenceDataLabels.Declaration]"></h1>

  <h3 class="chapter-title vo-heading-regular-18 mb-15" [innerHtml]="declarationDto.Labels[referenceDataLabels.Warning]"></h3>
  <div class="vo-body-regular-14" [innerHtml]="declarationDto.Labels[referenceDataLabels.DeclarationContent]"></div>

  <div class="declaration-controls-item my-30 border-black"
    *ngIf="declarationDto.Flags[referenceDataConstants.IntroducerDeclarationSection]">
    <div class="declaration-item vo-panel-white d-block p-30">
      <h3 class="chapter-title vo-heading-regular-18 mb-15" [innerHtml]="declarationDto.Labels[referenceDataLabels.IntroducerDeclarationTitle]">
      </h3>

      <div class="vo-body-regular-14" [innerHtml]="declarationDto.Labels[referenceDataLabels.IntroducerDeclarationContent]"></div>

      <boi-form-declaration-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        *ngIf="declarationDto.Flags[referenceDataConstants.IdentityVerification]"
        [labelName]="referenceDataLabels.WereApplicantsInterviewed"
        [(value)]="mortgageApplication.Consent.FaceToFaceInterview" [optionList]="declarationDto.IdentityVerification"
        [propertyNames]="['Consent.FaceToFaceInterview']">
      </boi-form-declaration-radio-button>
    </div>

    <boi-form-checkbox class="vo-panel-grey d-block p-15"  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      *ngIf="declarationDto.Flags[referenceDataConstants.AuthorityToComplete]"
      [propertyNames]="['Consent.AuthorityToCompleteConfirmed']" [controlId]="referenceDataLabels.IntroducerDeclaration"
      [checkboxLabel]="referenceDataLabels.IntroducerDeclaration | localizeLabel"
      [(value)]="mortgageApplication.Consent.AuthorityToCompleteConfirmed" [trueValue]="true" [falseValue]="undefined">
    </boi-form-checkbox>
  </div>

  <div class="declaration-controls-item vo-link-inside my-30 border-black" *ngIf="declarationDto.Flags[referenceDataConstants.ConsentSection]">
    <div class="declaration-item vo-panel-white d-block p-30">
      <h3 class="chapter-title vo-heading-regular-18 mb-15" [innerHtml]="declarationDto.Labels[referenceDataLabels.DeclarationAndConsent]"></h3>

      <div class="vo-body-regular-14" [innerHtml]="declarationDto.Labels[referenceDataLabels.DeclarationAndConsentContent]"></div>
    </div>

    <boi-form-checkbox class="vo-panel-grey d-block p-15" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      *ngIf="declarationDto.Flags[referenceDataConstants.ReadInsurance]"
      [propertyNames]="['Consent.ReadInsuranceDeclaration']" [controlId]="referenceDataLabels.InsuranceDeclaration"
      [checkboxLabel]="referenceDataLabels.InsuranceDeclaration | localizeLabel"
      [(value)]="mortgageApplication.Consent.ReadInsuranceDeclaration" [trueValue]="true" [falseValue]="undefined">
    </boi-form-checkbox>
  </div>

  <boi-marketing-declaration-content [declarationDto]="declarationDto"></boi-marketing-declaration-content>
</div>
